import React, { useContext, useState } from 'react';
import { Parallax } from "react-parallax";
import { Link } from "react-router-dom";
import { AppContext } from '../main';


const BlogPost = ({ image, date, title, link, description, tags }) => (
    <div className="col-lg-4 col-md-6 mb10">
        <div className="bloglist item">
            <div className="post-content">
                <div className="post-image">
                    <div className="d-tagline">
                        {tags.map((tag, index) => (
                            <span key={index}>{tag}</span>
                        ))}
                    </div>
                    <img src={image} alt={title} />
                </div>
                <div className="post-text">
                    <div className="d-date">{date}</div>
                    <h4>
                        <Link to={link}>
                            {title} <span></span>
                        </Link>
                    </h4>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    </div>
);

const Section = (props) => {
    const {
        handleEditItem
    } = props

    const { appState
    } = useContext(AppContext);
    const {
        blogs = {}
        , editMode = false
    } = appState

    if (!blogs?.blogs) {
        return null
    }

    // const content = {
    //     subtitle: "Latest From Us",
    //     title: "News & Promo",
    //     blogs: [
    //         {
    //             image: "./img/news/1.webp",
    //             date: "25.10.2023",
    //             title: "How to Set Up Your Own Game Server",
    //             link: "/",
    //             description:
    //                 "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
    //             tags: ["games", "guide"],
    //         },
    //         {
    //             image: "./img/news/2.webp",
    //             date: "25.10.2023",
    //             title: "Rise in Demand for Private Game Servers",
    //             link: "/",
    //             description:
    //                 "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
    //             tags: ["games", "guide"],
    //         },
    //         {
    //             image: "./img/news/3.webp",
    //             date: "25.10.2023",
    //             title: "Top Hosting Providers for Game Servers",
    //             link: "/",
    //             description:
    //                 "Dolore officia sint incididunt non excepteur ea mollit commodo ut enim reprehenderit cupidatat labore ad laborum consectetur consequat...",
    //             tags: ["games", "guide"],
    //         },
    //     ],
    // };

    return (
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6 offset-lg-3 text-center">
                    <div className="subtitle wow fadeInUp mb-3">{blogs.subtitle}</div>
                    <h2 className="wow fadeInUp" data-wow-delay=".2s">
                        {blogs.title}
                    </h2>
                    <div className="spacer-20"></div>
                </div>
            </div>
            <div className="row g-4">
                {blogs.blogs.map((post, index) => (
                    <BlogPost key={index} {...post} />
                ))}
            </div>
        </div>
    );
};

export default Section;
